export const apiDomain = "https://api.rutesapp.com";
export const hCaptchaSitekey = "e0babe09-2202-4ea1-9882-55edfc867418";
export const test = 1;
